"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isServerSideRendering_1 = __importDefault(require("./isServerSideRendering"));
/* eslint-disable consistent-return, no-return-assign */
function _appendToCookies(key, val) {
    if (typeof val === 'undefined')
        return document.cookie;
    return document.cookie += "; " + key + "=" + val;
}
/**
 * Sets a value for a new or existing cookie (uses `document.cookie`, but safely).
 * Will _not_ set a cookie value to `undefined` or `null`.
 *
 * @example
 * import setCookie from '@carvana/futilities/setCookie';
 * setCookie('latin', null)
 * // () => ''
 * setCookie('lorem', 'ipsum')
 * // () => 'lorem=ipsum'
 * setCookie('dolor', 'sit amet')
 * // () => 'lorem=ipsum; dolor=sit%20amet'
 * setCookie('dolor', 'sit')
 * // () => 'lorem=ipsum; dolor=sit%20amet'
 * setCookie('count', {one: 1, two: 2, three: 3})
 * // () => 'lorem=ipsum; dolor=sit%20amet; count=%7B%22one%22%3A1%2C%22two%22%3A2%2C%22three%22%3A3%7D'
 */
function setCookie(key, val) {
    if (isServerSideRendering_1.default())
        return;
    var cookieVal = val;
    try {
        if (/^({|\[)/.test(val)) {
            cookieVal = JSON.stringify(val);
        }
    }
    catch (err) {
        // Not able to be stringified as JSON, even though the string starts with a square or curly brace
    }
    if (cookieVal != null) {
        cookieVal = encodeURIComponent(cookieVal);
    }
    return _appendToCookies(key, cookieVal);
}
exports.default = setCookie;
//# sourceMappingURL=setCookie.js.map